// extracted by mini-css-extract-plugin
export default {"SubsectionSummary":"GqGg930FtiOGkHgCF5vg","name":"zSDCI7C1atFvRXamf2qX","quantity":"KQekb8AIC2VBKsba776S"};